import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRequest, postRequest } from '../../config/dataApi';
import ENDPOINTS from '../../config/apiUrls';

const initialState = {
  message: [],
  messageSeen: false,
  loading: false, // Whether login is in progress
  error: null, // Error message if any
};

export const broadcastMessage = createAsyncThunk(
  "auth/broadcastMessage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRequest(ENDPOINTS.BROADCAST.MESSAGE);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("something went wrong");
      }
    } catch (err) {
      return rejectWithValue(
        err.response ? err.response.message : "An error occurred."
      );
    }
  }
);


export const removebroadcastMessage = createAsyncThunk(
    'auth/removebroadcastMessage',
    async (id,{ rejectWithValue, getState }) => {
        try {
            const {auth} = getState();
            const response = await postRequest(ENDPOINTS.BROADCAST.REMOVE, {id,updated_by:auth.user.id});
            if (response.data) {
                return response.data;
            } else {
                return rejectWithValue('something went wrong');
            }
        } catch (err) {
            return rejectWithValue(err.response ? err.response.message : 'An error occurred.');
        }
    }
);

export const broadcastThisMessage = createAsyncThunk(
    'auth/broadcastThisMessage',
    async ({broadcast_msg},{ rejectWithValue, getState, dispatch }) => {
        try {
            const {auth} = getState();
            const response = await postRequest(ENDPOINTS.BROADCAST.MESSAGE_TO_LIVE, {broadcast_msg,owner:auth.user.id});
            if (response.data) {
                dispatch(broadcastMessage());
            } else {
                return rejectWithValue('something went wrong');
            }
        } catch (err) {
            return rejectWithValue(err.response ? err.response.message : 'An error occurred.');
        }
    }
);


const authSlice = createSlice({
    name: 'broadcastMessage',
    initialState,
    reducers: {
        hideMessage: (state) => {
            state.messageSeen = true;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(broadcastMessage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(broadcastMessage.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload;
            })
            .addCase(broadcastMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(removebroadcastMessage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(removebroadcastMessage.fulfilled, (state, action) => {
                state.loading = false;
                state.message = [];
            })
            .addCase(removebroadcastMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
           
    },
});
export const { hideMessage, clearError } = authSlice.actions;

export default authSlice.reducer;
